import React,
{
	useEffect,
	useState
}
from "react";

import {
	Navigate
}
from "react-router-dom";

import {
	doc,
	getDoc
}
from "firebase/firestore";

import {
	db
}
from "../firebase/firebaseConfig";

import {
	useAuth
}
from "../contextos/AuthContext";

import HomeV2
from "./HomeV2";

import ProfesorHome
from "./ProfesorHome";

import { leerInvitacionPendiente } from "../funciones/gruposServicio";

const InicioRouter = () => {

	const {
		usuario,
		cargando: cargandoAuth
	} = useAuth();

	

	const [
		cargando,
		setCargando
	] = useState(true);

	const [
		onboardingCompleto,
		setOnboardingCompleto
	] = useState(false);

	const [
		perfilActivo,
		setPerfilActivo
	] = useState(
		"estudiante"
	);


	useEffect(
	() => {

		if (!usuario) {

			setCargando(false);
			return;
		}

			const cargar =
				async () => {

					const ref =
						doc(
							db,
							"usuarios",
							usuario.uid
						);

					const snap =
						await getDoc(
							ref
						);

					if (
						snap.exists()
					) {

						const data =
							snap.data();

							let onboardingValido =
							data.onboardingCompleto === true;
						
						if (
							data.perfilActivo === "estudiante"
						) {
						
							onboardingValido =
						
								onboardingValido &&
						
								!!data.examenPrincipal &&
						
								!!data.horasSemana &&
						
								!!data.fechaObjetivo;
						
						}	

						setOnboardingCompleto(
							onboardingValido
						);

						setPerfilActivo(
							data.perfilActivo ||
							"estudiante"
						);
					}

					setCargando(
						false
					);
				};

			cargar();

		},
		[
			usuario
		]
	);

	if (
		cargandoAuth ||
		cargando
	) {
		return null;
	}

	const invitacionPendiente = leerInvitacionPendiente();

if (usuario && invitacionPendiente) {
	return <Navigate to={`/unirse/${invitacionPendiente}`} replace />;
}

	if (
		!onboardingCompleto
	) {

		return (
			<Navigate
				to="/onboarding"
				replace
			/>
		);
	}

	if (
	usuario &&
	perfilActivo === "profesor"
) {

	return (
		<ProfesorHome />
	);

}

return (
	<HomeV2 />
);
};

export default InicioRouter;